import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type CartItem = {
  id: number;
  title: string;
  image: string;
  description: string;
  price: number;
};

@Injectable({ providedIn: 'root' })
export class CartService {
  private readonly STORAGE_KEY = 'almino_cart_items';
  private items: CartItem[] = [];
  private itemsSubject = new BehaviorSubject<CartItem[]>([]);
  items$ = this.itemsSubject.asObservable();

  constructor() {
    this.loadItems();
  }

  private loadItems(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    if (saved) {
      try {
        this.items = JSON.parse(saved);
        this.itemsSubject.next(this.items);
      } catch (e) {
        console.error('Error loading cart from localStorage', e);
      }
    }
  }

  private saveItems(): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.items));
  }

  add(item: CartItem): void {
    const exists = this.items.some(p => p.id === item.id);
    if (!exists) {
      this.items = [...this.items, item];
      this.itemsSubject.next(this.items);
      this.saveItems();
    }
  }

  remove(id: number): void {
    this.items = this.items.filter(p => p.id !== id);
    this.itemsSubject.next(this.items);
    this.saveItems();
  }

  removeAll() {
    this.items = [];
    this.itemsSubject.next(this.items);
    this.saveItems();
  }

  has(id: number): boolean {
    return this.items.some(p => p.id === id);
  }

  count(): number {
    return this.items.length;
  }
}

